export default __webpack_public_path__ + "static/media/desktop_ellipse_2.221eed7c.svg";